import { Component, OnInit } from '@angular/core';
import {Brand} from "../../models/brand";
import {OwlOptions} from "ngx-owl-carousel-o";
import anime from 'animejs/lib/anime.es.js';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent implements OnInit {


  brands: Brand[] = [];

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    lazyLoad: true,
    margin: 40,
    dots: false,
    navSpeed: 200,
    nav: false,
    navText: ["<div class='nav-btn prev-slide  p-slider-arrow-left'>" +
    "<i class='la la-chevron-circle-left'></i></div>",
      "<div class='nav-btn next-slide p-slider-arrow-right'><i class='la la-chevron-circle-right'></i></div>"],
    // navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ],
    autoHeight: true,
    slideBy: '4',
    responsive: {
      0: {
        items: 5
      },
      400: {
        items: 5
      },
      740: {
        items: 6
      },
      840: {
        items: 8
      },
      900: {
        items: 10
      },
      940: {
        items: 12
      }
    }
  };


  constructor() { }

  ngOnInit(): void {

    this.brands.push(new Brand('ABB','ABB.png','abb'));
    this.brands.push(new Brand('Alba','Alba.png','alba'));
    this.brands.push(new Brand('Opple','Opple.png','Opple'));
    this.brands.push(new Brand('Alfanar','Alfanar.png','Alfanar'));

    this.brands.push(new Brand('Asfour','Asfour.png','Asfour'));
    this.brands.push(new Brand('Eaton','Eaton.png','Eaton'));
    this.brands.push(new Brand('Fumagalli','Fumagalli.png','Fumagalli'));
    this.brands.push(new Brand('Dahua','dahua.png','Dahua'));
    this.brands.push(new Brand('Kobak','Kobak.png','Kobak'));

    this.brands.push(new Brand('Power','Power.png','Power'));
    this.brands.push(new Brand('Shylon','Shylon.png','Shylon'));
    this.brands.push(new Brand('TJ','T&J.png','TJ'));

  }

  hoverAnim(event,brand){

    anime({
      targets: 'div#'+brand.name,
      scale:1.1,
      duration: 800,
      translateY: -5,
    });

  }

  hoverOutAnim(event,brand){


    anime({
      targets: 'div#'+brand.name,
      translateY: 0,
      duration: 800,
      scale:1,
    });
  }

}
